import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel
} from 'react-accessible-accordion';

import DirectAdmitMap from '@img/constellation-map-da.svg';
import imgHELP09 from '@img/Homepage/UWHelp-09.jpg';
import imgHELP10 from '@img/Homepage/UWHelp-10.jpg';
import imgHELP11 from '@img/Homepage/UWHelp-11.jpg';
import imgHELP12 from '@img/Homepage/UWHelp-12.jpg';
import { scrollTo } from '@modules/_misc';
import _svg from '@modules/svg';
import { userActions } from '@reducers/user';
import ContactUsModal from '@views/Public/Modals/ContactUs';
import Header from '@views/Public/shared-content/home-header';
import Footer from '@views/Public/shared-content/home-footer';
import ShowNotifications from '@views/Public/shared-content/show-notifications';
import withRouter from '@wrappers/withRouter';

const Home = props => {
	const { location, mainContent, directAdmit, faqs } = props,
		dispatch = useDispatch(),
		logout = () => dispatch(userActions.logout()),
		[contactUsModal, setContactUsModal] = useState(false),
		{ logging_out } = location.state || {};

	useEffect(() => {
		if (logging_out) logout();
		scrollTo();
	}, []);

	return (
		<div className='body' role='main'>
			<ContactUsModal show={contactUsModal} closeModal={() => setContactUsModal(false)} />

			<Header />

			<div className='content'>
				<div>
					<img
						className='image-2'
						src={directAdmit ? DirectAdmitMap : _svg.constellationMap}
						alt='Map of the Universities of Wisconsin'
					/>
				</div>
				<div>{mainContent}</div>
			</div>

			<ShowNotifications />

			<div className='faqs'>
				{imageBar}

				<div className='faq-container'>
					<div className='faqs-heading'>
						<h1 className='heading'>Frequently asked questions</h1>
						<div className='text-block'>
							Your question not on the list?{' '}
							<a className='link' rel='noopener noreferrer' onClick={() => setContactUsModal(true)}>
								Contact us.
							</a>
						</div>
					</div>
					<div className='faq-wrap'>
						<Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
							{faqs.map((faq, i) => (
								<AccordionItem key={i}>
									<AccordionItemHeading>
										<AccordionItemButton>
											{faq.header}
											<img className='accordionPlus' src={_svg.HomepagePlus} alt='UW Logo' />
										</AccordionItemButton>
									</AccordionItemHeading>
									<AccordionItemPanel>{faq.item}</AccordionItemPanel>
								</AccordionItem>
							))}
						</Accordion>
					</div>
				</div>
			</div>

			<Footer />
		</div>
	);
};

export default withRouter(Home);

const imageBar = (
	<div className='image-bar'>
		<img
			src={imgHELP09}
			srcSet={`${imgHELP09} 500w, ${imgHELP09} 600w`}
			sizes='(max-width: 479px) 100vw, (max-width: 991px) 50vw, (max-width: 1439px) 25vw, 360px'
			alt=''
			className='hp-photo a'
		/>

		<img
			src={imgHELP10}
			srcSet={`${imgHELP10} 500w, ${imgHELP10} 600w`}
			sizes='(max-width: 479px) 100vw, (max-width: 991px) 50vw, (max-width: 1439px) 25vw, 360px'
			alt=''
			className='hp-photo b'
		/>

		<img
			src={imgHELP11}
			srcSet={`${imgHELP11} 500w, ${imgHELP11} 600w`}
			sizes='(max-width: 991px) 100vw, (max-width: 1439px) 25vw, 360px'
			alt=''
			className='hp-photo c'
		/>

		<img
			src={imgHELP12}
			srcSet={`${imgHELP12} 500w, ${imgHELP12} 600w`}
			sizes='(max-width: 991px) 100vw, (max-width: 1439px) 25vw, 360px'
			alt=''
			className='hp-photo d'
		/>
	</div>
);
